import type { Router } from 'vue-router';
import type { RrMainMenuItemImpl } from '@seedkit/vue';

function routeNameFromMenuTo(to: RrMainMenuItemImpl['to']): string | null {
  if (to == null || to === '') return null;
  if (typeof to === 'string') return to;
  if (typeof to === 'object' && to !== null && 'name' in to) {
    const n = (to as { name?: unknown }).name;
    return typeof n === 'string' ? n : null;
  }
  return null;
}

function routeLinkResolvable(router: Router, to: RrMainMenuItemImpl['to']): boolean {
  const name = routeNameFromMenuTo(to);
  if (name === null) return true;
  return router.hasRoute(name);
}

/**
 * Убирает пункты с именованными маршрутами, которые ещё не зарегистрированы в роутере
 * (динамические маршруты модулей после IAM).
 */
export function filterMainMenuByRouter(
  items: RrMainMenuItemImpl[],
  router: Router,
): RrMainMenuItemImpl[] {
  const out: RrMainMenuItemImpl[] = [];
  for (const item of items) {
    const childrenFiltered = item.children?.length
      ? filterMainMenuByRouter(item.children, router)
      : undefined;
    const hasChildren = Boolean(childrenFiltered?.length);
    const selfOk = routeLinkResolvable(router, item.to);
    if (!selfOk && !hasChildren) continue;

    if (childrenFiltered?.length) {
      out.push({ ...item, children: childrenFiltered });
    } else {
      const rest = { ...item };
      delete (rest as { children?: unknown }).children;
      out.push(rest as RrMainMenuItemImpl);
    }
  }
  return out;
}
